// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__1Yq0j","tooltipBody":"Tooltip_tooltipBody__3TVo7","heading":"Tooltip_heading__1nyM_","details":"Tooltip_details__2AlhO"};